var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "119px",
    width: "324px",
    viewBox: "0 0 324 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62B1E",
    d: "m32.678 30.831h-32.678l-1.4211e-14 -29.981h101.56v29.981h-32.685v87.469h-36.197v-87.469zm74.502-29.981h98.75v29.981h-62.55v14.462h62.55v28.212h-62.55v14.814h62.55v29.981h-98.75v-117.45zm104.72 0h59.39c39.01 0 52.71 28.923 52.71 58.551 0 35.975-18.98 58.899-59.74 58.899h-52.36v-117.45zm36.2 87.469h14.05c22.49 0 25.66-18.337 25.66-29.27 0-7.41-2.46-27.865-28.47-27.865h-11.6l0.36 57.135z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTedLogo);
export default __webpack_public_path__ + "static/media/ted_logo.060bf261b46a56712a5aee9a02ec9807.svg";
export { ForwardRef as ReactComponent };